import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage, getLocation } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import React from "react";
import { connect } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => {
    const session = state.context.session;
    const { search, pathname } = getLocation(state);
    const isAuthenticated = session && session.isAuthenticated;

    return {
        currentPage: getCurrentPage(state),
        homeBranch: getSettingsCollection(state) as any,
        breadcrumbLinks: state.components.breadcrumbs.links,
        search: search,
        pathname: pathname,
        isAuthenticated: isAuthenticated,
    };
};

export interface BranchNameStyles {
    branchName?: TypographyProps;
}

const branchNameStyles: BranchNameStyles = {
    branchName: {
        css: css`
            text-transform: capitalize;
            margin: 0 0 42px;
            @media only screen and (max-width:767px) {font-size: 24px;margin: 0 0 14px;}
        `,
    },
};

type Props = ReturnType<typeof mapStateToProps> & HasHistory;

const ShopMyBranchHeading = ({
    currentPage,
    homeBranch,
    breadcrumbLinks,
    history,
    search,
    pathname,
    isAuthenticated,
}: Props) => {
    const newHomeBranch: string = homeBranch.maNavSettingSettings?.billtoDeafultWareHouseDescription?.toLowerCase();

    React.useEffect(() => {
        if (!isAuthenticated) {
            history.push(`/MyAccount/SignIn?returnUrl=${pathname}${search}`);
        }
    }, [isAuthenticated]);

    return (
        <Typography variant={"h1"} {...branchNameStyles.branchName}>
            {`${newHomeBranch} Branch`}
        </Typography>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(withHistory(ShopMyBranchHeading)),
    definition: {
        group: "Categories",
        displayName: "Shop My Branch Heading",
    },
};

export default widgetModule;